import React, { useState } from 'react';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import { Input, Button, Select } from 'antd';
import { Refresh, Search, ArrowDropDown } from '@material-ui/icons';

type SegmentsFilter = {
  searchText: string;
  handleSearch: (e: any) => void;
  onSort: (e: string) => void;
  onApplyFilter: () => void;
};

const { Option } = Select;

const SegmentsFilter: React.FC<SegmentsFilter> = ({ searchText, handleSearch, onSort, onApplyFilter }) => {
  const intl = useIntl();
  const agentSorts = [
    { value: 'Idesc', label: intl.formatMessage({ id: 'ID (desc)' }) },
    { value: 'Iasc', label: intl.formatMessage({ id: 'ID (asc)' }) },
    { value: 'Nasc', label: intl.formatMessage({ id: 'Name (A-Z)' }) },
    { value: 'Ndesc', label: intl.formatMessage({ id: 'Name (Z-A)' }) },
  ];

  const handleSort = (value: string) => {
    onSort(value);
  };

  const sortOptions = agentSorts.map(item => {
    let isDisabled = false;

    return (
      <Option
        value={item.value}
        key={item.label}
        disabled={isDisabled}
        style={{ fontFamily: 'Lato', color: '#242c40' }}
      >
        {item.label}
      </Option>
    );
  });

  return (
    <div className="segments_filter_layout" id="segments_filter_layout">
      <Select
        className="sort_by"
        suffixIcon={<ArrowDropDown />}
        placeholder={intl.formatMessage({ id: 'Sort by' })}
        onChange={handleSort}
        id="segments_name_filter"
        dropdownStyle={{ paddingLeft: '0', paddingRight: '0' }}
      >
        {sortOptions}
      </Select>
      <Button className="apply_filters_btn" onClick={onApplyFilter} id="segments_apply_filters_btn">
        <FormattedMessage id="Apply filters" />
        <Refresh />
      </Button>
      <Input
        suffix={<Search />}
        placeholder={intl.formatMessage({ id: 'Search the segments' })}
        value={searchText}
        onChange={e => handleSearch(e)}
        onKeyDown={e => handleSearch(e)}
        id="segments_search_input"
        maxLength={200}
      />
    </div>
  );
};

export default SegmentsFilter;
